import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import RoleInfo from "./RoleInfo";
import "./ViewRole.css";

const ViewRole = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const roleData = location.state?.data;
  const webPermissionNames = location.state?.webPermissionNames;
  const mobilePermissionNames = location.state?.mobilePermissionNames;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="rov-header-banner">
        <button type="button" className="rov-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="rov-header-icon">
          <ShieldCheck size={14} color="#fff" />
        </span>
        <div>
          <div className="rov-header-title">View Role</div>
          <div className="rov-header-subtitle">Role details and permission levels</div>
        </div>
      </div>
      <RoleInfo
        roleData={roleData}
        webPermissionNames={webPermissionNames}
        mobilePermissionNames={mobilePermissionNames}
      />
    </div>
  );
};

export default ViewRole;
